<template lang='pug'>
  el-dialog(title="设置提醒", :visible.sync="visible")
    el-form(label-width="80px")
      el-form-item(label="提醒对象")
        el-select(v-model="person")
          el-option(v-for="p in persons" :key="p._id" :label="p.account" :value="p._id")
      el-form-item(label='日期时间')
        el-date-picker(v-model="clock"
          type="datetime"
          placeholder="选择日期时间")
      el-form-item(label='提醒内容')
        el-input(v-model="content")
    span(slot="footer")
      el-button(@click="cancelRemind") 取消
      el-button(@click="submitRemind", type="primary") 确认
</template>

<script>
// Generated by CoffeeScript 2.3.0
var dateFormat, m;

dateFormat = require('dateformat');

export default m = {
  data: function() {
    return {
      person: '',
      persons: [],
      clock: '',
      content: '',
      visible: false,
      item: {}
    };
  },
  methods: {
    show: function(item) {
      app.api.find({
        tableName: 'users'
      }).then((users) => {
        return this.persons = users;
      });
      this.item = item;
      this.person = app.user._id;
      if (item['姓名'] && item['手机']) {
        this.content = '联系 ' + item['姓名'] + '：' + item['手机'];
      }
      return this.visible = true;
    },
    // console.log @person, 1
    cancelRemind: function() {
      this.person = '';
      this.clock = '';
      this.content = '';
      return this.visible = false;
    },
    submitRemind: function() {
      if (!this.clock) {
        this.$message('请填写提醒时间');
        return false;
      }
      return app.service('users').get(this.person).then((p) => {
        var clock, remind, time;
        if (p.remind == null) {
          p.remind = [];
        }
        remind = p.remind;
        clock = Date.parse(this.clock) / 1000;
        time = dateFormat(this.clock, 'yyyy-mm-dd HH:MM:ss');
        remind.push({
          clock: clock,
          content: this.content,
          time: time
        });
        return app.service('users').patch(p._id, {
          remind: remind
        });
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '设置成功'
        });
        return this.cancelRemind();
      });
    }
  }
};
</script>

